import React from 'react';
import * as ReactDOM from "react-dom";
import {withRouter} from "../withRouter";
import {NavLink} from "react-router-dom";
import ModeratorGames from "./ModeratorGames";

class ModeratorActivity extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            error: null,
            loginError: null,
            actions: []
        };
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + '/my-account/try-login-via-cache', {
            method: "POST",
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then(res => res.json())
            .then(
                (result) => {
                    if (result.role.name !== 'moderator' && result.role.name !== 'admin') {
                        this.setState({
                            isLoaded: true,
                            loginError: 'unauthorized'
                        });
                    } else {
                        this.setState({
                            isLoaded: true,
                            userId: result.id
                        });
                    }
                },
                (error) => {
                    this.setState({
                        isLoaded: false,
                        error,
                    });
                }
            );

        fetch(process.env.REACT_APP_API_URL + "/moderator/"+this.props.moderatorId.toString()+"/actions", {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        actions: result
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    render() {
        const { isLoaded, loginError, error, actions  } = this.state;

        const { navigate } = this.props;

        if (loginError) {
            navigate('/account');
        }

        if (isLoaded) {
            return <div>
                <h1>Recent activity</h1>
                {actions.map(item => (
                    <div>
                        <hr/>
                        <NavLink
                            to={"/games/" + item.game_id.toString()}
                        >
                            {item.game.name} - {item.type}
                        </NavLink>
                        <br/>
                        Fields:
                        {item.fields.map(item => (<li>{item}</li>))}
                    </div>
                ))}
                <hr/>
            </div>;
        } else {
            return <h1>Loading...</h1>
        }

    }
}

export default withRouter(ModeratorActivity);
